import PropTypes from 'prop-types';
export var price = PropTypes.shape({
  amount: PropTypes.number.isRequired,
  code: PropTypes.string,
  credits: PropTypes.number,
  discountBy: PropTypes.string,
  discountPercentage: PropTypes.number,
  isDiscounted: PropTypes.bool,
  originalPrice: PropTypes.string,
  price: PropTypes.string,
  subMultiple: PropTypes.number,
  symbol: PropTypes.string.isRequired,
  discounts: PropTypes.object
});
export var storedCard = PropTypes.shape({
  number: PropTypes.string
});
export var countryCode = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});
export var amount = PropTypes.shape({
  amount: PropTypes.number.isRequired,
  symbol: PropTypes.string.isRequired,
  code: PropTypes.string
});